import React from "react";
import "./ProductSalePage.css";
import ProductSalesOverview from "./ProductSalesOverview";
import Letsgetintouch from "../../PLMImplementation/BusinessProcessAndChangeManagement/Letsgetintouch";
import ProductSalesBanner from "../ProductSalesBanner/ProductSalesBanner";
import ProductOfferSection from "../ProductSalesCard/ProductOfferSection";
import ProductSalesServices from "../productsaleservices/ProductSalesServices";
import ProductSalesWhyNextech from "../ProductSalesWhyNextech/ProductSalesWhyNextech";
import FlowChart from "../flowchart/FlowChart";


const ProductPage = () => {
  return (
    <section className="business-process">

      <ProductSalesBanner />

      <ProductSalesOverview />
      <ProductOfferSection/>
    
      <ProductSalesServices />
   
      <section style={{ background: "#062c3f" }}>
        <FlowChart />
      </section>
      
    
      <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
          <h4 className="solution-page-heading">Unlock the Power :</h4>
          <h5 className="solution-subheading">
            Discover the Transformative Benefits of Product with  NexTech!
          </h5>
          <ul className="custom-bullets">
            <li>
            Embrace Teamcenter PLM in true business sense. 
            </li>
            <li>Assured robust PLM vision, strategy and long-term roadmap. </li>
            <li>
            Assured optimum investment in Teamcenter PLM licenses. 
            </li>
            <li>
            Value added implementation. 
            </li>
            <li>
            Single source of product sales and implementation services. 
            </li>
          </ul>
        </div>
      </section>




      <section style={{ background: "#062c3f" }}>
        <div className="why-nextech ">
         <ProductSalesWhyNextech/>
        </div>
      </section>

      <Letsgetintouch />
      
    </section>
  );
};

export default ProductPage;
